import { render, staticRenderFns } from "./CalcComponent.vue?vue&type=template&id=35782786&scoped=true&"
import script from "./CalcComponent.vue?vue&type=script&lang=js&"
export * from "./CalcComponent.vue?vue&type=script&lang=js&"
import style0 from "./CalcComponent.vue?vue&type=style&index=0&id=35782786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35782786",
  null
  
)

export default component.exports